export class Navigation{
	init(){
		$('.site-header li').each(function() {
			var $this = $(this);
			if($this.children('.submenu').length){
				$this.addClass('has-child');
			}else if($this.children('ul').length){
				$this.addClass('has-list');

				var w = $this.innerWidth();
				$this.closest('.submenu').css('width',  w+=w);
			}
		})
	}
}